function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { isEmptyTextNode } from './dom-utils.js';
import { SlotObserver } from './slot-observer.js';
import { generateUniqueId } from './unique-id-utils.js';
/**
 * A controller for providing content to slot element and observing changes.
 */

export var SlotController = /*#__PURE__*/function (_EventTarget) {
  _inherits(SlotController, _EventTarget);

  var _super = _createSuper(SlotController);

  function SlotController(host, slotName, tagName) {
    var _this;

    var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, SlotController);

    _this = _super.call(this);
    var initializer = config.initializer,
        multiple = config.multiple,
        observe = config.observe,
        useUniqueId = config.useUniqueId;
    _this.host = host;
    _this.slotName = slotName;
    _this.tagName = tagName;
    _this.observe = typeof observe === 'boolean' ? observe : true;
    _this.multiple = typeof multiple === 'boolean' ? multiple : false;
    _this.slotInitializer = initializer;

    if (multiple) {
      _this.nodes = [];
    } // Only generate the default ID if requested by the controller.


    if (useUniqueId) {
      _this.defaultId = _this.constructor.generateId(host, slotName);
    }

    return _this;
  }

  _createClass(SlotController, [{
    key: "hostConnected",
    value: function hostConnected() {
      if (!this.initialized) {
        if (this.multiple) {
          this.initMultiple();
        } else {
          this.initSingle();
        }

        if (this.observe) {
          this.observeSlot();
        }

        this.initialized = true;
      }
    }
    /** @protected */

  }, {
    key: "initSingle",
    value: function initSingle() {
      var node = this.getSlotChild();

      if (!node) {
        node = this.attachDefaultNode();
        this.initNode(node);
      } else {
        this.node = node;
        this.initAddedNode(node);
      }
    }
    /** @protected */

  }, {
    key: "initMultiple",
    value: function initMultiple() {
      var _this2 = this;

      var children = this.getSlotChildren();

      if (children.length === 0) {
        var defaultNode = this.attachDefaultNode();

        if (defaultNode) {
          this.nodes = [defaultNode];
          this.initNode(defaultNode);
        }
      } else {
        this.nodes = children;
        children.forEach(function (node) {
          _this2.initAddedNode(node);
        });
      }
    }
    /**
     * Create and attach default node using the provided tag name, if any.
     * @return {Node | undefined}
     * @protected
     */

  }, {
    key: "attachDefaultNode",
    value: function attachDefaultNode() {
      var host = this.host,
          slotName = this.slotName,
          tagName = this.tagName; // Check if the node was created previously and if so, reuse it.

      var node = this.defaultNode; // Tag name is optional, sometimes we don't init default content.

      if (!node && tagName) {
        node = document.createElement(tagName);

        if (node instanceof Element) {
          if (slotName !== '') {
            node.setAttribute('slot', slotName);
          }

          this.node = node;
          this.defaultNode = node;
        }
      }

      if (node) {
        host.appendChild(node);
      }

      return node;
    }
    /**
     * Return the list of nodes matching the slot managed by the controller.
     * @return {Node}
     */

  }, {
    key: "getSlotChildren",
    value: function getSlotChildren() {
      var slotName = this.slotName;
      return Array.from(this.host.childNodes).filter(function (node) {
        // Either an element (any slot) or a text node (only un-named slot).
        return node.nodeType === Node.ELEMENT_NODE && node.slot === slotName || node.nodeType === Node.TEXT_NODE && node.textContent.trim() && slotName === '';
      });
    }
    /**
     * Return a reference to the node managed by the controller.
     * @return {Node}
     */

  }, {
    key: "getSlotChild",
    value: function getSlotChild() {
      return this.getSlotChildren()[0];
    }
    /**
     * Run `slotInitializer` for the node managed by the controller.
     *
     * @param {Node} node
     * @protected
     */

  }, {
    key: "initNode",
    value: function initNode(node) {
      var slotInitializer = this.slotInitializer; // Don't try to bind `this` to initializer (normally it's arrow function).
      // Instead, pass the host as a first argument to access component's state.

      if (slotInitializer) {
        slotInitializer(node, this.host);
      }
    }
    /**
     * Override to initialize the newly added custom node.
     *
     * @param {Node} _node
     * @protected
     */

  }, {
    key: "initCustomNode",
    value: function initCustomNode(_node) {}
    /**
     * Override to teardown slotted node when it's removed.
     *
     * @param {Node} _node
     * @protected
     */

  }, {
    key: "teardownNode",
    value: function teardownNode(_node) {}
    /**
     * Run both `initCustomNode` and `initNode` for a custom slotted node.
     *
     * @param {Node} node
     * @protected
     */

  }, {
    key: "initAddedNode",
    value: function initAddedNode(node) {
      if (node !== this.defaultNode) {
        this.initCustomNode(node);
        this.initNode(node);
      }
    }
    /**
     * Setup the observer to manage slot content changes.
     * @protected
     */

  }, {
    key: "observeSlot",
    value: function observeSlot() {
      var _this3 = this;

      var slotName = this.slotName;
      var selector = slotName === '' ? 'slot:not([name])' : "slot[name=".concat(slotName, "]");
      var slot = this.host.shadowRoot.querySelector(selector);
      this.__slotObserver = new SlotObserver(slot, function (_ref) {
        var addedNodes = _ref.addedNodes,
            removedNodes = _ref.removedNodes;
        var current = _this3.multiple ? _this3.nodes : [_this3.node]; // Calling `slot.assignedNodes()` includes whitespace text nodes in case of default slot:
        // unlike comment nodes, they are not filtered out. So we need to manually ignore them.

        var newNodes = addedNodes.filter(function (node) {
          return !isEmptyTextNode(node) && !current.includes(node);
        });

        if (removedNodes.length) {
          _this3.nodes = current.filter(function (node) {
            return !removedNodes.includes(node);
          });
          removedNodes.forEach(function (node) {
            _this3.teardownNode(node);
          });
        }

        if (newNodes && newNodes.length > 0) {
          if (_this3.multiple) {
            // Remove default node if exists
            if (_this3.defaultNode) {
              _this3.defaultNode.remove();
            }

            _this3.nodes = [].concat(_toConsumableArray(current), _toConsumableArray(newNodes)).filter(function (node) {
              return node !== _this3.defaultNode;
            });
            newNodes.forEach(function (node) {
              _this3.initAddedNode(node);
            });
          } else {
            // Remove previous node if exists
            if (_this3.node) {
              _this3.node.remove();
            }

            _this3.node = newNodes[0];

            _this3.initAddedNode(_this3.node);
          }
        }
      });
    }
  }], [{
    key: "generateId",
    value:
    /**
     * Ensure that every instance has unique ID.
     *
     * @param {HTMLElement} host
     * @param {string} slotName
     * @return {string}
     * @protected
     */
    function generateId(host, slotName) {
      var prefix = slotName || 'default';
      return "".concat(prefix, "-").concat(host.localName, "-").concat(generateUniqueId());
    }
  }]);

  return SlotController;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));